export const formatDateString = (date: string) =>
  new Date(date)?.toLocaleString("en-US", {
    weekday: "short",
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: false,
  });
export const formatDateToString = (date: string) =>
  new Date(date)?.toLocaleString("en-US", {
    weekday: "short",
    year: "numeric",
    month: "short",
    day: "numeric",
    hour12: false,
  });
